import { Injectable } from "@angular/core";
import { ApiService } from "./api/bff-prompts";
import { Observable, of } from "rxjs";
import { catchError } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class StatsService {
  private readonly endpoints = ['dados/top10', 'prompt/avaliacao/top10', 'avaliacao/top10'];

  constructor(private apiService: ApiService) {}

  getTop10(): Observable<any> {
    return this.tryEndpoints(0);
  }

  private tryEndpoints(index: number): Observable<any> {
    if (index >= this.endpoints.length) {
      return of({ data: { content: [], empty: true } });
    }
    const endpoint = this.endpoints[index];
    return this.apiService.get<any>(endpoint).pipe(
      catchError(() => this.tryEndpoints(index + 1))
    );
  }
}
